"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _environment = require("../../constants/environment");

var _noop = require("../../constants/noop");

/* eslint-disable no-console */
var warn = _environment.ENABLE_LOGGING && console && console.warn ? console.warn.bind(console) : _noop.noop;
var _default = warn;
exports["default"] = _default;